import { AuthSubscriptions } from '@hefe/auth';
import { t } from '@hefe/i18n';
import {
  BasketballEventType,
  BasketballPractice,
  BasketballTeam,
  EventHelpoutEventableType,
  UserBasic,
} from '@hefe/models';
import { currentUserSelector } from '@hefe/store';
import { clubHasSubscription } from '@hefe/utils';
import { Button, Descriptions, Space } from 'antd';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import EventDetailsRepliesComponent from '../../event-details/event-details-replies/event-details-replies.component';
import EventDetailsTeamTasksComponent from '../../event-details/event-details-team-tasks/event-details-team-tasks.component';
import EventTeamHelpoutsComponent from '../../event-team-helpouts/event-team-helpouts.component';
import EventTeamNomineesComponent from '../../event-team-nominees/event-team-nominees.component';

interface PracticeDetailsTeamComponentProps {
  practice: BasketballPractice;
  team: BasketballTeam;
  userCoaches: UserBasic[];
}

export default function PracticeDetailsTeamComponent(
  props: PracticeDetailsTeamComponentProps
) {
  const [nomineesModalOpen, setNomineesModalOpen] = useState(false);

  const user = useSelector(currentUserSelector);

  const nominatedPlayersText = useMemo(() => {
    if (!props.team.nominees || props.team.nominees?.length === 0) {
      return t('nominees.all_players_nominated');
    }

    return t('nominees.number_of_nominated_players', {
      count: props.team.nominees?.length,
    });
  }, [props.team.nominees]);

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <EventDetailsTeamTasksComponent
          coaches={props.team.user_coaches || []}
          eventId={props.practice.id}
          eventType={BasketballEventType.PRACTICE}
          players={props.team.user_players || []}
          teamPlayers={props.team.playerReplies}
          tasks={props.team.tasks}
          teamId={props.team.id}
        />
      </div>
      <Descriptions column={1} size="small" bordered>
        {clubHasSubscription(AuthSubscriptions.second, user) && (
          <Descriptions.Item label={t('helpouts.title')}>
            <EventTeamHelpoutsComponent
              helpouts={props.team.helpouts ?? []}
              eventType={EventHelpoutEventableType.BASKETBALL_PRACTICE}
              eventId={props.practice.id}
              teamId={props.team.id}
            />
          </Descriptions.Item>
        )}
        {clubHasSubscription(AuthSubscriptions.third, user) && (
          <Descriptions.Item label={t('nominees.nominated_players')}>
            <Space direction="horizontal">
              <Button
                type="link"
                onClick={() => setNomineesModalOpen(true)}
                style={{ padding: 0, margin: 0 }}
              >
                {nominatedPlayersText}
              </Button>
            </Space>
          </Descriptions.Item>
        )}
      </Descriptions>
      <EventDetailsRepliesComponent
        allowViewReplies={true}
        replies={props.team.playerReplies}
        eventId={props.practice.id}
        eventType={BasketballEventType.PRACTICE}
        isCoach={props.userCoaches.length > 0}
        team={props.team}
      />
      <EventTeamNomineesComponent
        open={nomineesModalOpen}
        onClose={() => setNomineesModalOpen(false)}
        players={props.team?.playerReplies}
        eventId={props?.practice.id}
        eventType={BasketballEventType.PRACTICE}
        teamId={props.team.id}
      />
    </div>
  );
}
